import { createContext, useContext, useState, useEffect } from 'react';

const AuthContext = createContext();

export function AuthProvider({ children }) {
  const [authenticatedProjects, setAuthenticatedProjects] = useState(() => {
    // Load authenticated projects from sessionStorage
    const stored = sessionStorage.getItem('authenticatedProjects');
    return stored ? JSON.parse(stored) : [];
  });

  const [isAdminAuthenticated, setIsAdminAuthenticated] = useState(() => {
    // Load admin auth from sessionStorage
    return sessionStorage.getItem('adminAuth') === 'true';
  });

  useEffect(() => {
    // Save to sessionStorage whenever it changes
    sessionStorage.setItem('authenticatedProjects', JSON.stringify(authenticatedProjects));
  }, [authenticatedProjects]);

  useEffect(() => {
    // Save admin auth to sessionStorage
    sessionStorage.setItem('adminAuth', isAdminAuthenticated ? 'true' : 'false');
  }, [isAdminAuthenticated]);

  const isProjectAuthenticated = (slug) => {
    return authenticatedProjects.includes(slug);
  };

  const authenticateProject = (slug) => {
    if (!authenticatedProjects.includes(slug)) {
      setAuthenticatedProjects([...authenticatedProjects, slug]);
    }
  };

  const logoutProject = (slug) => {
    setAuthenticatedProjects(authenticatedProjects.filter(s => s !== slug));
  };

  const authenticateAdmin = () => {
    setIsAdminAuthenticated(true);
  };

  const logoutAdmin = () => {
    setIsAdminAuthenticated(false);
  };

  const logoutAll = () => {
    setAuthenticatedProjects([]);
    setIsAdminAuthenticated(false);
    sessionStorage.clear();
  };

  return (
    <AuthContext.Provider
      value={{
        isProjectAuthenticated,
        authenticateProject,
        logoutProject,
        isAdminAuthenticated,
        authenticateAdmin,
        logoutAdmin,
        logoutAll,
      }}
    >
      {children}
    </AuthContext.Provider>
  );
}

export function useAuth() {
  const context = useContext(AuthContext);
  if (!context) {
    throw new Error('useAuth must be used within an AuthProvider');
  }
  return context;
}
